import { baseURL, formatFetchError, fetchHeaders } from '../util'
import { Api, Vehicle } from '@cruz-com/lookup'

export async function searchByBodyType(id: string, params: object): Promise<Api.Result<Vehicle.Summary[]>> {
  try {
    const res = await fetch(`${baseURL}/vehicle/search/body-type/:id?${new URLSearchParams({ ...params, body_type: id })}`, {
      method: 'GET',
      headers: await fetchHeaders(),
      next: { revalidate: 3 }
    })
    const d: Api.Result<Vehicle.Summary[]> = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}